import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-667ce2c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col-centered selection-container" }
const _hoisted_2 = ["for"]


export default /*#__PURE__*/_defineComponent({
  __name: 'TitledSelection',
  props: {
    for: {},
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.for
        }, _toDisplayString(_ctx.title), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})